import {
  enableLinkClickTracking,
  LinkClickTrackingPlugin,
} from '@snowplow/browser-plugin-link-click-tracking'
import {
  setUserId as setSnowplowUserId,
  trackPageView as snowplowTrackPageView,
  newTracker,
  enableActivityTracking,
  trackSelfDescribingEvent,
  CommonEventProperties,
  SelfDescribingEvent,
} from '@snowplow/browser-tracker'
import { secrets } from '@chilipiper/config'
import mixpanel from 'mixpanel-browser'
export { trackSelfDescribingEvent } from '@snowplow/browser-tracker'
import { environment } from '@chilipiper/config'

let isMixpanelInitialized = false

export const initTracking = (appId = 'app') => {
  console.log(`initializing tracking ${appId} ${environment.deploy}`) // eslint-disable-line no-console
  newTracker('spTracker', secrets.snowplowEndpoint, {
    appId,
    plugins: [LinkClickTrackingPlugin()],
    stateStorageStrategy: 'cookieAndLocalStorage',
    discoverRootDomain: true,
    cookieSameSite: 'None',
    cookieSecure: true,
  })
  enableLinkClickTracking()
  enableActivityTracking({
    minimumVisitLength: 30,
    heartbeatDelay: 10,
  })

  const isMixpanelEnabled = appId === 'fire-admin-center' && environment.deploy === 'production'

  if (isMixpanelEnabled) {
    mixpanel.init(secrets.mixpanel, {
      // @ts-ignore -- mixpanel types are outdated < 2.60.0
      // it's according to the docs https://docs.mixpanel.com/docs/quickstart/capture-events/autocapture
      autocapture: {
        pageview: 'full-url',
        click: true,
        input: true,
        scroll: true,
        submit: true,
        capture_text_content: true,
      },
      ignore_dnt: true,
      track_pageview: true,
      api_host: 'https://mixpanel-proxy.chilipiper.com',
    })
    isMixpanelInitialized = true
  }
}

export const trackPageView = () => {
  snowplowTrackPageView()
}

export const setTrackingUserId = (userId: string) => {
  setSnowplowUserId(userId)
  if (isMixpanelInitialized) {
    mixpanel.identify(userId) // this throws an error if called when Mixpanel is not initialized
  }
}

export const trackSchemedEvent = (event: SelfDescribingEvent & CommonEventProperties) => {
  trackSelfDescribingEvent(event)
}
